<template>

    <div class="widget widget-filters widget-filters--offcanvas--mobile" data-collapse data-collapse-opened-class="filter--opened">
        <div class="widget__header widget-filters__header">
            <h4>Search Filters</h4>
        </div>

        <div class="widget-filters__item" v-if="customerIndicator == 'B'">
            <div class="filter filter--opened" data-collapse-item>                                                       
                <div class="filter__body" data-collapse-content>
                    <div class="filter__container">
                        <div class="filter-vehicle">
                            <ul class="filter-vehicle__list">
                                <li class="filter-vehicle__item ">
                                    <label class="filter-vehicle__item-label">
                                        <span class="filter-list__input input-radio">
                                            <span class="input-radio__body">
                                                <!-- :checked="selections.Available == true" -->
                                                <input class="input-radio__input" name="filter_stocks" type="radio" value="Y" v-model="selections.Available" @change="tick_filters">
                                                <span class="input-radio__circle"></span>
                                            </span>
                                        </span>
                                        <span class="filter-vehicle__item-title font-on-hand">
                                            <strong>AVAILABLE</strong>
                                        </span>
                                        <span class="filter-vehicle__item-counter"></span>
                                    </label>
                                </li>
                                <li class="filter-vehicle__item ">
                                    <label class="filter-vehicle__item-label">
                                        <span class="filter-list__input input-radio">
                                            <span class="input-radio__body">
                                                <input class="input-radio__input" name="filter_stocks" type="radio" value="N" v-model="selections.Available" @change="tick_filters">
                                                <span class="input-radio__circle"></span>
                                            </span>
                                        </span>
                                        <span class="filter-vehicle__item-title">
                                            All Parts
                                        </span>
                                        <span class="filter-vehicle__item-counter"></span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <!-- part types -->
        <div class="widget-filters__item">
            <div data-collapse-item  :class="(open_ftypes === true) ? 'filter filter--opened' : 'filter' " >
                <button type="button" class="filter__title" data-collapse-trigger @click="open_ftypes = !open_ftypes">
                    Part Types
                    <span class="filter__arrow"><svg width="12px" height="7px">
                            <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                        </svg></span>
                </button>
                <div class="filter__body" data-collapse-content>
                    <div class="filter__container">
                        <div class="filter-list">
                            <div class="filter-list__list">
                                <label class="filter-list__item"  v-for="(ptype, i) in filter_ptypes" :key="i">
                                    <span class="input-check filter-list__input">
                                        <span class="input-check__body">
                                            <input class="input-check__input" type="checkbox" :value="ptype.val.toUpperCase()" v-model="selections.PartTypes" @change="tick_filters">
                                            <span class="input-check__box"></span>
                                            <span class="input-check__icon"><svg width="9px" height="7px">
                                                    <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                </svg>
                                            </span>
                                        </span>
                                    </span>
                                    <span class="filter-list__title text-uppercase">
                                        {{ ptype.val }}
                                    </span>
                                    <span class="filter-list__counter"> {{ ptype.count }}</span>
                                </label>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- brands/manufacturers -->
        <div class="widget-filters__item">
            <div data-collapse-item :class="(open_fbrand === true) ? 'filter filter--opened' : 'filter' ">
                <button type="button" class="filter__title" data-collapse-trigger @click="open_fbrand = !open_fbrand">
                    Brand
                    <span class="filter__arrow"><svg width="12px" height="7px">
                            <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                        </svg></span>
                </button>
                <div class="filter__body" data-collapse-content>
                    <div class="filter__container">
                        <div class="filter-list">
                            <div class="filter-list__list">
                                <label class="filter-list__item "  v-for="(brand, i) in filter_brands" :key="i">
                                    <span class="input-check filter-list__input ">
                                        <span class="input-check__body">
                                            <input class="input-check__input" type="checkbox" :value="brand.val.toUpperCase()" v-model="selections.Brands" @change="tick_filters">
                                            <span class="input-check__box"></span>
                                            <span class="input-check__icon"><svg width="9px" height="7px">
                                                    <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                </svg>
                                            </span>
                                        </span>
                                    </span>
                                    <span class="filter-list__title text-uppercase">
                                        {{ brand.val }}
                                    </span>
                                    <span class="filter-list__counter"> {{ brand.count }}</span>
                                </label> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="viewMore === true">
            <div class="widget-filters__item" v-for="(cfilter, indx) in __filters" :key="indx">
                <div data-collapse-item :class="(cfilter.collapse === true) ? 'filter filter--opened' : 'filter' " >
                    <button type="button" class="filter__title" data-collapse-trigger @click="cfilter.collapse = !cfilter.collapse">
                        {{ cfilter.filter.replace(/_/g, " ") }}
                        <span class="filter__arrow">
                            <svg width="12px" height="7px">
                                <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                            </svg>
                        </span>
                    </button>
                    <div class="filter__body" data-collapse-content>
                        <div class="filter__container">
                            <div class="filter-list">
                                <div class="filter-list__list">
                                    <label class="filter-list__item" v-for="(cf, i) in cfilter.values.filter(f => f.val != '')" :key="i">
                                        <span class="input-check filter-list__input " v-if="cf.val != ''">
                                            <span class="input-check__body">
                                                <input class="input-check__input"  type="checkbox"  :value="cf.val" v-model="selections[cfilter.filter]"
                                                @change="tick_filters(cfilter.filter)" />
                                                <span class="input-check__box"></span>
                                                <span class="input-check__icon">
                                                    <svg width="9px" height="7px">
                                                        <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                        <span class="filter-list__title text-uppercase">
                                            {{ cf.val.toUpperCase() }}
                                        </span>
                                        <span class="filter-list__counter"> {{ cf.count }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="widget-filters__actions d-flex">
            <button class="btn btn-primary btn-sm" @click="showMoreFilters">{{btnFilterCaption}}</button>
            <button class="btn btn-primary btn-sm" @click="search">Search</button>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import axiosvl from "../../../axios/axios-vl.js";
import SolrHelper from '../../../mixins/solr_helper';


export default {
    mixins:  [SolrHelper],
    props: {
        facet_filters: {
            type: Object,
        },
        level : {
            type: Number,
        },
        categoryUri1: {
            type: String
        },
        categoryUri2: {
            type: String
        },
        categoryUri3: {
            type: String
        },
        categoryUri4: {
            type: String
        },
        categoryUri5: {
            type: String
        },
        categoryUri6: {
            type: String
        },
        categoryUri7: {
            type: String
        },
        categoryUri8: {
            type: String
        },
        categoryUri9: {
            type: String
        },
    },

    data() {
        return {
            viewMore : false,
            btnFilterCaption : 'More Filter Options',
            facet_field_uri: '&facet.field=IGDESC&facet.field=MCNAME&facet=true',
            perPage: 1000,
            // filter toggles
            open_fcolor: true,
            open_fbrand: true,
            open_fweight: true,
            open_fprice: true,
            open_ftypes: true,

            filter_ptypes: [],
            filter_colors: [],
            filter_brands: [],
            filter_weight: [],
            filter_prices: [],
            filter_more : [],

            ffields: [],

            dfields: ['IGDESC', 'MCNAME'],

            defaultSels: {
                Available: "Y",
                Stocks: false,
                Category: '',
                PartTypes: [],
                Brands: [],
                Colors: [],
                Weights: [],
                Prices: [],
            },

            selections: {
                Available: "Y",
                Stocks: false,
                Category: '',
                PartTypes: [],
                Brands: [],
                // Colors: [],
                // Weights: [],
                // Prices: [],
            }
            
        }
    },

    watch: {
        level() {
            console.log('watch level');
            const state_facet_filtler = this.$store.getters.cat_faceted_filter;
            if(state_facet_filtler == null){
                this.selections = this.defaultSels;
                this.solr_search();
            }else{
                this.selections = state_facet_filtler;
                this.solr_search(this.selections);
            }
            
        },
        categoryUri1() {
            // console.log('facet newlevel = ' + newVal);
            this.selections = this.defaultSels;
            // console.log(this.selections);
            this.solr_search();
        },
    },

    computed: {
        ...mapGetters(['customerIndicator']),

        subcats() {
            const categories = this.$store.getters['product/categories'];
            const code1 = this.$route.params.categoryUri;
            const category_level = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.categorylevel === 2)));

            return category_level;
        },
        __filters() {
            // console.log(this.filter_more);
            return this.filter_more;
        },
    },

    methods: {
        // , cVal = null
        tick_filters(cfilter = null){
            console.log(cfilter);
            this.$emit('filter_changed', this.selections);
            this.solr_search(this.selections);
            if(this.$route.name == 'CategoryDrilldown' || this.$route.name == 'Category') {
                this.$store.dispatch('setCat_faceted_filter', this.selections);
            }
        },

        rebuildFilter(facet_filters) {
            // console.log(facet_filters);
            this.filter_colors = [];
            this.filter_brands = [];
            this.filter_prices = [];
            this.filter_weight = [];
            this.filter_ptypes = [];
            this.filter_more = [];
            
            var i,j;
            // console.log(chunk);

            // let a = 0;
            for(const filter in facet_filters){
                const fvalues = [];
                if(filter != 'MCNAME' && filter != 'IGDESC' && filter != 'count' ){
                    if(this.selections[filter] == undefined){
                        this.selections[filter] = [];
                    }
                    for (i = 0,j = facet_filters[filter].buckets.length; i < j; i++) {
                        fvalues.push(facet_filters[filter].buckets[i]);
                    }
                    fvalues.sort((a,b) => (a['val'] > b['val']) ? 1 : ((b['val'] > a['val']) ? -1 : 0));
                    if(fvalues.length > 0){
                        this.filter_more.push({
                            filter: filter,
                            collapse: true,
                            values: fvalues
                        });
                    }
                }
            }

            for (i = 0,j = facet_filters.MCNAME.buckets.length; i < j; i++) {
                this.filter_brands.push(facet_filters.MCNAME.buckets[i]);
            }
            this.filter_brands.sort((a,b) => (a['val'] > b['val']) ? 1 : ((b['val'] > a['val']) ? -1 : 0));
            // this.filter_brands.sort((a,b) => (a[0] > b[0]) ? 1 : ((b[0] > a[0]) ? -1 : 0));
            // console.log(this.filter_brands);

            for (i = 0,j = facet_filters.IGDESC.buckets.length; i < j; i++) {
                // facet_filters.IGDESC.buckets.slice(i, i + chunk)
                this.filter_ptypes.push(facet_filters.IGDESC.buckets[i]);
            }
            this.filter_ptypes.sort((a,b) => (a['val'] > b['val']) ? 1 : ((b['val'] > a['val']) ? -1 : 0));

        },

        // remove filter from active filters section
        removeFilter(f) {
            switch(f){
                case 'all':
                    for(const rf in this.selections){
                        if(rf == 'Available'){
                            this.selections[rf] = 'Y';
                        }else if(rf == 'Stocks') {
                            this.selections[rf] = 'N';
                        }else{
                            this.selections[rf] = [];
                        }
                    }
                    this.selections.Category = '';
                    // this.selections =  this.defaultSels;                    
                    break;
                case 'PartTypes':
                    this.selections.PartTypes = [];
                    break;
                case 'Brands':
                    this.selections.Brands = [];
                    break;
                case 'Colors':
                    this.selections.Colors = [];
                    break;
                case 'Weights':
                    this.selections.Weights = [];
                    break;
                case 'Prices':
                    this.selections.Prices = [];
                    break;
                case 'Stocks':
                    this.selections.Stocks = 'Y';
                    break;
                case 'Available':
                    this.selections.Stocks = 'Y';
                    break;
                case 'Category':
                    this.selections.Category = '';
                    break;
                default:
                    // this.selections =  this.defaultSels;
                    // this.filter_more[f] = [];
                    this.selections[f] = [];
                    break;
            }
            // console.log(this.filter_more);
            this.$emit('filter_changed', this.selections);
            console.log(this.selections);
            this.solr_search(this.selections);
        },

        reset(){
            this.selections = this.defaultSels;
            this.$emit('filter_changed', this.selections);
        },

        search() {
            // console.log(this.$route.fullPath);
            // const url = this.$route.fullPath.replace("category", "category-search");
            // const filters_uri  = this.mx_url_builder(this.selections);

            // this.$router.push(url +  '?'  + filters_uri);
            // console.log(this.selections);
            this.$emit('view_parts', this.selections);
        },

        /**
         * show/hide more filters
         */
        showMoreFilters() {
            this.viewMore = !this.viewMore;
            if (this.viewMore == true) {
                this.solr_search(this.selections);
                this.$emit('view_parts', this.selections);
                this.btnFilterCaption = 'Hide Filter Options';
            }else{
                // this.$emit('show_more_filter', false);
                this.btnFilterCaption = 'More Filter Options';
            }
        },

        setSubcat(subcat_code){
            this.selections.Category = subcat_code;
            this.$emit('filter_changed', this.selections);
        },

        async solr_search(filters = null, currentPage = 1) {
            const rows = this.perPage;
            const start = this.perPage * (currentPage - 1);
            // const custom_attr = this.$store.getters['product/custom_attrs'];
            const catCode = this.$route.params.categoryUri1;
            
            this.$emit('clear_messages');
            this.parts = [];
            this.more_filters = [];
            this.isloading = true;

            const ffields = this.ffields;
            let filter_uri = '';
            let json_facet_uri = '';
            // console.log(this.$route.query);

            json_facet_uri = this.mx_json_facet(ffields);

            if(filters != null){
                filter_uri = this.mx_multi_facet_filter(filters);
            }else{
                // defaults filter search
                // &fq=Stocking_Flag:Y
                filter_uri = '&fq=Stocks:[1 TO *]';
            }
            
            let lvl = 1;
            let l = '';

            while(lvl <= this.level){
                if(lvl < 10){
                    l = '0' + lvl;
                }else{
                    l = lvl;
                }
                
                filter_uri += '&fq=DMCD'+l+':' + this.$route.params['categoryUri' + lvl];
                lvl += 1;
            }

            filter_uri += json_facet_uri;
            console.log('json_facet_uri = ' + json_facet_uri);

            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            let uri = solr_host + '/select?q.op=AND&q=DMCD01%3A'+catCode+'&facet.field=IGDESC&facet.field=MCNAME&facet=true&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight&group=true&group.field=Item&group.facet=true&group.format=simple&group.ngroups=true';
            let paginate_uri = '&rows=' + rows + '&start=' + start;

            uri += filter_uri + this.facet_field_uri + paginate_uri;

            await axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                const MPARTS = response.data.grouped.Item.doclist.docs;
                const resp_facets = response.data.facets;
                // console.log(resp_facets);
                this.facets = resp_facets;
                this.numFound  = response.data.grouped.Item.ngroups;
                this.facets = resp_facets;
                // const invalidattr = ['Recommended_Use'];
                

                MPARTS.forEach(product => {
                    const clearProductDesc = encodeURIComponent(product.Item_Desc);

                    // this.getProductDetails(obj);
                    this.parts.push({
                        manufacturer: product.DXMFGC,
                        sku: product.Item,
                        // customer: obj.CMCUST,
                        // location: defaultLoc,
                        IMMFGC: product.DXMFGC,
                        manufacturerdesc: product.MCNAME,
                        IMITMC: product.Item,
                        description: product.Item_Desc,
                        XRMFGC: '',
                        XRITMC: '',
                        DEDESC: '',
                        IMIGSA: product.IGCODE_SAG,
                        IMISVALID: '',
                        mfgSeo: product.MCNAME.replace(/ /g, "-"),
                        // itemSeo: product.Item_Desc.replace(/ /g, "-"),
                        itemSeo: clearProductDesc.replace(/ /g, "-"),
                        // !NC! image: obj.EPIMG1,
                        image: product.Image,

                        // from Nic @ issue #260
                        // if it is B2B use QTYAVL
                        // if it is B2C use TOTOH
                        // stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                        stockquantity: product.Stocks,
                        // stockquantity: 1,
                        // stockqty: 1,
                        // list_price: fields.EILSTP.value,
                        // extended_price: fields.EIEXCP.value,
                        // core_charge: fields.EICORP.value,
                    });
                });

                // console.log(custom_attr);
                    
                // custom_attr.forEach(attr => {
                //     if (invalidattr.find(i => i == attr)){
                //         return;
                //     }
                //     // console.log('PRODUCT ATTR  = ' +  obj[attr]);
                //     if (product[attr] != undefined && typeof product[attr] === 'string' && product[attr].trim() != ''){
                //         if(this.more_filters.indexOf(attr) < 0 && this.more_filters.length < 5) {
                //             this.more_filters.push(attr);
                //         }
                //     }
                // });

                // do not reset current facet fields that has shown
                // if(this.facet_field_uri != '')
                // this.more_filters.forEach(attr => {
                //     //  build the URI on the next  call
                //     this.facet_field_uri += '&facet.field='+attr;
                //     // console.log(resp_facets[attr]);
                //     if(resp_facets[attr] != undefined){
                //         this.facets.facet_fields[attr] = resp_facets[attr].buckets;
                //     }
                // });
                
                // console.log(this.facets);
                this.rebuildFilter(this.facets);

                this.$emit('total_items', this.numFound);
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },
        
        more_filter() {
            const uri = this.$store.getters['api/cat_prod_attr_uri'];
            const fields = {
                'LW3SFID' : {'value': this.$store.getters.storefront },
            };
            let lvl = 1;
            let l;

            while(lvl <= this.level){
                if(lvl < 10){
                    l = '0' + lvl;
                }else{
                    l = lvl;
                }
                fields['DMCD' + l] = {value: this.$route.params['categoryUri' + lvl]};
                lvl += 1;
            }

            axiosvl.post(uri,{
                webroutine: {
                    context: {
                        "session-key-method": "hidden",
                    },
                    fields: fields,
                },
            })
            .then((response) => {
                // console.log(response);
                const lists = response.data.webroutine.lists;
                const LS_CATPROD_ATTR = lists.LS_CATPROD_ATTR.entries;
                console.log(LS_CATPROD_ATTR);
                const ffields = [];
                this.dfields.forEach(f => {
                    ffields.push(f);
                })

                LS_CATPROD_ATTR.forEach((obj) => {
                    let solr_field;
                    if(obj.LW3SLRFLD != ''){
                        solr_field = obj.LW3SLRFLD.replaceAll(' ', '_');
                    }else{
                        solr_field = obj.LW3IATNM.replaceAll(' ', '_');
                    }
                    
                    ffields.push(solr_field);
                });

                this.ffields = ffields;

                this.solr_search(this.selections);
            });
        }
    },

    updated() {
        // if(this.facet_filters){
        //     this.rebuildFilter();
        // }
        // console.log('faceted panel updated');
    },

    created() {
        // console.log('faceted panel created');
        // console.log(this.$router);
        console.log('Page Name = ' + this.$router.currentRoute._value.name);
        // get the faceted filter from the vuex
        if(this.$store.getters.cat_faceted_filter != null && this.$router.currentRoute._value.name == 'KeywordSearchResults'){
            this.selections = this.$store.getters.cat_faceted_filter;
            // this.solr_search(this.selections);
            this.more_filter();
            return;
        }

        if(this.$store.getters.cat_faceted_filter != null && this.$router.currentRoute._value.name == 'PartsDiagram'){
            this.selections = this.$store.getters.cat_faceted_filter;
            // this.solr_search(this.selections);
            this.more_filter();
            return;
        }

        if(this.$store.getters.cat_faceted_filter != null && this.$router.currentRoute._value.name == 'CategoryDrilldown'){
            this.selections = this.$store.getters.cat_faceted_filter;
            this.more_filter();
            return;
        }

        if(this.$store.getters.cat_faceted_filter != null && this.$router.currentRoute._value.name == 'Category'){
            this.$store.dispatch('setCat_faceted_filter', null);  
        }

        // clear the faceted filter selections 
        this.selections = this.defaultSels;
        // this.solr_search();
        this.more_filter();
    }
}
</script>

<style scoped>
    .text-uppercase {
        text-transform: uppercase;
    }

    .text-capital {
        text-transform: capitalize;
    }
    .filter-list__list{
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>